import { render, staticRenderFns } from "./InforStrip.vue?vue&type=template&id=48d6ebfa&scoped=true"
import script from "./InforStrip.vue?vue&type=script&lang=js"
export * from "./InforStrip.vue?vue&type=script&lang=js"
import style0 from "./InforStrip.vue?vue&type=style&index=0&id=48d6ebfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6ebfa",
  null
  
)

export default component.exports